import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const CRM_API = axios.create({
  baseURL: `${BACKEND}/api/crm`,
  withCredentials: true,
});
export const AUTH_API = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

// Central error extraction — ALWAYS returns a string. FastAPI 422 responses
// carry detail as an array of {type, loc, msg, input, ctx} objects; returning
// that raw array crashed React when it was rendered (black screen).
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const msgs = d
      .map((x) => {
        if (typeof x === "string") return x;
        const field = Array.isArray(x?.loc) ? x.loc[x.loc.length - 1] : null;
        return field && x?.msg ? `${field}: ${x.msg}` : x?.msg;
      })
      .filter(Boolean);
    return msgs.length ? msgs.join("; ") : "Validation error";
  }
  if (d && typeof d === "object") return d.msg || d.message || "Request failed";
  if (typeof e?.response?.data === "string") return e.response.data;
  return e?.message || "Unexpected error";
};
